module.exports = __webpack_public_path__ + "img/change-test.bedd4ee1.svg";